import BackofficeController from "backoffice_controller";

import Tagify from "@yaireo/tagify";

// This controller works with Backoffice::Form::Content::InputComponent having the following attributes :
// - stimulus_controller: "bo-tagify"
// - data_attributes: {
//   bo_tagify_target: "tags" (toujours),
//   tags_collection: An array of arrays with [a tag_id, a tag_value_to_display]. Ex: "[[5,"QUALIPARIS"],[13,"Tourisme \u0026 handicap"],[10,"Ecojardin"]]"
//   existing_tags: Same format than tags_collection, to get the persisted tags. Ex: form.object.labels.pluck(:id; :name)
//   nested_ressource_name: a string with the name of the tagified ressource. Ex: for Service.last.labels each tag is a label so "label".
// }

export default class extends BackofficeController {
  static targets = ["tags"];

  static values = {
    tags: String,
  };

  initialize() {}

  connect() {
    this._initTagify();
  }

  _initTagify = () => {
    const tagsCollection = JSON.parse(this.tagsTarget.dataset.tagsCollection);
    const existingTags = JSON.parse(this.tagsTarget.dataset.existingTags);
    const nestedRessourceName = this.tagsTarget.dataset.nestedRessourceName;

    let tags = [];

    tagsCollection.forEach((item) => {
      tags = [...tags, {
        value: item[1].trim(),
        [`${nestedRessourceName}_id`]: item[0],
      }];
    });

    const tagify = new Tagify(this.tagsTarget, {
      whitelist: tags,
      enforceWhitelist: true,
      editTags: false,
      originalInputValueFormat: (valuesArr) => {
        return valuesArr.map((item) => item[`${nestedRessourceName}_id`]).join(",");
      },
      dropdown: {
        maxItems: 100,
        classname: "tags-look",
        enabled: 0,
        closeOnSelect: false,
      },
    });

    // load existing tags
    let tagsToInsert = [];
    existingTags.forEach((item) => {
      tagsToInsert.push({
        value: item[1].trim(),
        [`${nestedRessourceName}_id`]: item[0],
      });
    });

    tagify.addTags(tagsToInsert);
    tagify.updateValueByDOMTags();
  };
}
